module.exports = __webpack_public_path__ + "img/fr.f689ce44.svg";